// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"308":"5b04cb38","362":"46979bc5","453":"b9568c39","535":"9a766dd8","928":"b874e71a"}[chunkId] + ".chunk.js";
};